import { alerts } from './alerts';

import '../../libs/spinner';

/**
 * Use to sending data attributes  with ajax
 *
 * @param btnClass {string}  - click button class
 * @param typeEvent {string} - name event
 * @param parentForm {boolean} -class parent for submit
 * @param initPluginFunction {Function} -callback for reinit plugins
 *
 */

export class SendAjaxFromEl{

  constructor(btnClass, typeEvent, initPluginFunction,  parentForm ){

    this.btn = btnClass;
    this.typeEvent = typeEvent;
    this.initPlugin = initPluginFunction;

    this.parentForm = parentForm === true ? parentForm : false;

    this.method = "POST";
    this.action = '/';
    this.token = '';
    this.data = {};

    this.resultBlk ='';
    this.replaceBlk ='';
    this.modal = false;
  }

  /**
   * init function
   */
  onInit(){
    let _this = this;

    $('body').on(this.typeEvent, this.btn, function(e){

      if(this.typeEvent === 'click'){
        e.preventDefault();
      }

      if(_this.parentForm){
        let $elForSubmit = $($(this).attr('data-form'));
        if($elForSubmit.length != 0){
          _this.data = _this.getData($elForSubmit);
        }
      }else{
        _this.data = _this.getData($(this));
      }

      _this.addSpinner('formsendHover', 'form-loading');
      _this.sendRequest();

    });
    let $modal_result = $('.js_base_modal_empty');
    $modal_result.on('hidden.bs.modal', function() {
      $modal_result.removeAttr('data-result-blk').removeAttr('data-replace-blk');
    });
  }
  addSpinner(idSpinner, classLoader){
    if($(this.resultBlk).length !== 0){
      $(this.resultBlk).spinnerAdd(idSpinner, classLoader);
      return;
    }
    if($(this.replaceBlk).length !== 0){
      $(this.replaceBlk).spinnerAdd(idSpinner, classLoader);
      return;
    }
    $.spinnerAdd(idSpinner, classLoader)
  }
  /**
   * get data from button
   *
   * @param el - button with data attributes
   */
  getData(el){
    let data = el.data();
    if(data.resultBlk !== undefined){
      this.resultBlk = data.resultBlk;
      delete data.resultBlk;
    }
    if(data.replaceBlk !== undefined){
      this.replaceBlk = data.replaceBlk;
      delete data.replaceBlk;
    }
    if(data.modal !== undefined){
        this.modal = data.modal;
        delete data.modal;
    }

    //the el is form
    if(el.is('form')){
      return this.getDataForm(el, data);
    }

    //remove data  plugins
    if(data['bs.tooltip'] !== undefined) {
      delete data['bs.tooltip'];
    }
    if(data['select2'] !== undefined){
      delete data['select2'];
    }
    if(data['datepicker'] !== undefined){
      delete data['datepicker'];
    }

    if(data.method !== undefined){
      this.method = data.method;
      delete data.method;
    }
    if(data.action !== undefined){
      this.action = data.action;
      delete data.action;
    }

    //for element form (example: checkbox or select)
    let nameEl = el.attr('name');

    if(!(nameEl == undefined || nameEl == '') ){
      if(el[0].type && el[0].type === 'checkbox'){
        if(el[0].checked){
          data[nameEl] = 1;
        }else {
          data[nameEl] = 0;
        }
      }else{
        data[nameEl] = el.val();
      }
    }
    data._token = app.csrf_token;
    return data;
  }

  /**
   * @param form {el}
   * @param data {object}
   */
  getDataForm(form, data){
    if(form.attr('action') !== undefined){
      this.action = form.attr('action');
    }
    if(form.attr('method') !== undefined){
      this.method = form.attr('method');
    }

    //checkbox
    let checkbox = form.find("input[type=checkbox]");

    checkbox.each(function(item, el){
      if (el.checked) {
        el.value = 1
      }
      if (data.sendAllCheckbox && !el.checked) {
        el.value = 0
      }
    });
    return form.serialize();
  }
  /**
   * ajax request
   */
  sendRequest(){
    if(this.method.toUpperCase() !== 'GET' && this.method.toUpperCase() !== 'POST'){
      this.data._method = this.method;
      this.method = 'POST';
    }
    $.ajax({
      url: this.action,
      method: this.method,
      data: this.data,
      success: (data) => {
        if (data.redirect !== undefined) {
          window.location.replace(data.redirect);
          return;
        }
        this.successSubmit(data);
      },
      error: (data) => {
        this.errorSubmit(data);
      }
    })
  }

  /**
   * append data to resultBlk
   * @param data - data from back
   */
  successSubmit(data){
    let $modalCnt = $('.js_base_modal_empty');
    if(this.modal){
      $.spinnerRemove('formsendHover', 'form-loading');

      $modalCnt.attr('data-result-blk', this.resultBlk);
      $modalCnt.attr('data-replace-blk', this.replaceBlk);
      $modalCnt.modal('show').find('.modal-body').html(data);

      //reinit plugin
      if(typeof  this.initPlugin == 'function') {
        this.initPlugin('.js_base_modal_empty');
      }
      return;
    }
    if($(this.btn).closest('.js_base_modal_empty').length !== 0){
      console.log('in modal event')
      this.resultBlk = $modalCnt.attr('data-result-blk') === undefined ? '' : $modalCnt.attr('data-result-blk');
      this.replaceBlk = $modalCnt.attr('data-replace-blk') === undefined ? '' : $modalCnt.attr('data-replace-blk');
      $modalCnt.modal('hide');
    }

    if(this.replaceBlk !=='' && $(this.replaceBlk).length !== 0){

      let thisBlk =  $(this.replaceBlk).replaceWithPush(data);
      if(typeof  this.initPlugin == 'function'){
        let classThisBlk = ('.'+thisBlk[0].className.match(/[\d\w-_]+/g).join('.'));
        this.initPlugin(classThisBlk);
      }

      $.spinnerRemove('formsendHover', 'form-loading');
      return;
    }

    if(this.resultBlk !=='' && $(this.resultBlk).length !== 0){
      $(this.resultBlk).html(data);
      if(typeof  this.initPlugin == 'function') {
        this.initPlugin(this.resultBlk);
      }
    }else{
      alerts.success('Done');
    }
    $.spinnerRemove('formsendHover', 'form-loading');
  }

  /**
   * error function
   *
   * @param data - data from back
   */
  errorSubmit(data){
    $.spinnerRemove('formsendHover', 'form-loading');
    if(data === undefined || ( !data.responseJSON && !data.responseJSON.errors)){
      alerts.error('Error');
      return;
    }
    alerts.error(data.responseJSON.message);
  }
}



// WEBPACK FOOTER //
// ./js/script/components/ajax_el.js